import { ViteReactSSG } from "vite-react-ssg"
import { routes } from "./routes"
import "./styles/globals.css"

// Para los previews (CI) la app se sirve bajo una subruta (p. ej. /previews/mi-rama/).
// Vite expone esa base en import.meta.env.BASE_URL; React Router la usa como basename.
const base = import.meta.env.BASE_URL
const basename = base === "/" ? undefined : base.replace(/\/+$/, "")

export const createRoot = ViteReactSSG({ routes, basename })
